import React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@dhn/lib/utils";

const buttonVariants = cva(
  "dhn-ui-button tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-semibold tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
  {
    variants: {
      variant: {
        default:
          "dhn-ui-button--default tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/90",
        destructive:
          "dhn-ui-button--destructive tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90",
        outline:
          "dhn-ui-button--outline tw-border tw-border-input tw-bg-background hover:tw-bg-accent hover:tw-text-accent-foreground",
        secondary:
          "dhn-ui-button--secondary tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
        ghost: "dhn-ui-button--ghost hover:tw-bg-accent hover:tw-text-accent-foreground",
        link: "dhn-ui-button--link tw-text-primary tw-underline-offset-4 hover:tw-underline",
      },
      size: {
        default: "dhn-ui-button--size-default tw-h-10 tw-px-4 tw-py-2",
        sm: "dhn-ui-button--size-sm tw-h-9 tw-rounded-md tw-px-3",
        lg: "dhn-ui-button--size-lg tw-h-11 tw-rounded-md tw-px-8",
        icon: "dhn-ui-button--size-icon tw-h-10 tw-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";

    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);

Button.displayName = "Button";

export { Button, buttonVariants };
